import { SelectionModel } from '@angular/cdk/collections';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormControl, UntypedFormControl } from '@angular/forms';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { ThemePalette } from '@angular/material/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { NodeDefinition, TreeComponent, TreeNode } from 'enel-tree';
import { Context, ContextSelectorService, GlobalNavService, Space } from 'ngx-global-nav';
import { BehaviorSubject, combineLatest, merge, Observable, of } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { CheckableSettings, SelectableSettings } from 'src/app/shared/interface';
import { iconDefinitions, iconMap } from 'src/app/shared/model/icons.definitions';
import { User } from 'src/app/shared/model/user.model';
import { BusinessRole, DR_NOTIFICATION_ROLES, DR_ROLES_TO_SUBSCRIPTIONS } from '../../shared/model/business-role.model';
import { BusinessRolesService } from '../../shared/services/business-roles.service';
import { DrGroupService } from '../../shared/services/dr-group.service';
import { ItsService } from '../../shared/services/its.service';
import { SpaceService } from '../../shared/services/space.service';
import { UserService } from '../../shared/services/user.service';
import { DefaultRoleService } from '../../shared/services/default-role.service';

export interface AdminGroupList {
  letter: string;
  names: string[];
}

export const _filter = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();
  return opt.filter((item) => item.toLowerCase().startsWith(filterValue));
};
export interface Group extends TreeNode<any> {
  completed: boolean;
  color: ThemePalette;
  subgroups?: Group[];
}
@Component({
  selector: 'app-location-roles',
  templateUrl: './location-roles.component.html',
  styleUrls: ['./location-roles.component.scss'],
})
export class LocationRolesComponent implements OnInit, OnDestroy {
  private readonly treeDataSubject = new BehaviorSubject<TreeNode<any>[]>([]);
  treeData$: Observable<TreeNode<any>[]> = this.treeDataSubject.asObservable();

  iconDefinitions = iconDefinitions;
  iconMap = iconMap;

  roleCtrl = new FormControl('');
  chipsFormControl = new FormControl([]);
  selectedItemType;
  isRoleDisabled;

  isInit = true;
  loadingHierarchy = true;
  loadingRoles = true;
  applyingRoles = false;
  subscriptions: any[] = [];
  illegalSubs: any[] = [];
  context: Context;

  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredRoles$: Observable<BusinessRole[]>;
  allRoles: BusinessRole[];
  allSpaceRoles: BusinessRole[] = [];
  selectedRoles: BusinessRole[] = [];
  @ViewChild('roleInput') roleInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @ViewChildren('roleCheckbox') roleCheckboxes: QueryList<MatCheckbox>;

  disableItems = false;
  loadedALLOrgs = [];

  nodes: TreeNode<any>[] = [];
  orgnodes: TreeNode<any>[];
  marketNodes: TreeNode<any>[];
  allAdminGroups: TreeNode<any>[];
  drGroups;

  currentDRType: BehaviorSubject<string> = new BehaviorSubject<string>('SpaceEntity');

  disabledNodeDefinitions: NodeDefinition = { space_type: ['SpaceGroup'] };
  labelIdentifier = 'display_label';
  iconIdentifier = 'spaceType';
  defaultNodes: string[] = [];
  treeSelection: SelectionModel<TreeNode<any>>;
  selectedSpaces: TreeNode<any>[] = [];

  searchText = '';
  isHierarchy = false;
  expandedKeys: string[] = [];
  selectedKeys: Set<TreeNode<any>> = new Set<TreeNode<any>>();
  selection: SelectableSettings;
  userDefaultNode: string;
  userDefaultNodeLabel: string;
  showOnlyPrimaryOrg = true;

  ctrlShowAD = new UntypedFormControl(false);
  currentTab = 0;

  voice_notification_user = 'DR_VOICE_NOTIFICATIONS_USER';
  sms_notification_user = 'DR_SMS_NOTIFICATIONS_USER';
  email_notification_user = 'DR_EMAIL_NOTIFICATIONS_USER';
  dr_user = 'DR_GENERAL_USER';
  isVoiceValid = true;
  isSMSValid = true;
  isEmailValid = true;

  @Input() hasEcrm: boolean;

  @Input() userId: string;
  @Input() mode: string;
  @Input() isOnboarding: boolean;
  loggedInUser: User;
  managerLocale: string;
  defaultRolesApplied = false;

  @Output() applyingRolesEvent = new EventEmitter<boolean>();
  @Output() roleError = new EventEmitter<string>();
  @Output() onRoleAdd = new EventEmitter();
  spaces: Space[];

  showOrgSelected = 'optionMainOrg';

  multiSelect = true;
  forceSelection = false;
  checkbox = true;
  parentSelectable = false;
  expandable = true;
  search = true;
  controls = true;
  hideIrrelevant = false;
  allowDeselectAll = true;
  cascadeSelect = true;
  expandAll = false;
  hideDisabledCheckbox = false;
  selectAllResults = true;
  maxSelections = 0;
  searchPlaceholder = '';
  expandedNodes: Set<TreeNode<any>> = new Set<TreeNode<any>>();
  selectedNode = '';
  deselectedNode = '';
  searchProperties: string[] = ['displayLabel'];
  shownExpandedNodes: TreeNode<any>[] = [];
  shownSelectedNodes: TreeNode<any>[] = [];
  clickedNode: TreeNode<any> | undefined;
  disableRoleSelection = false;

  @ViewChild('locationTree') locationTree: TreeComponent<any>;

  constructor(
    private readonly drGroupService: DrGroupService,
    private readonly rolesService: BusinessRolesService,
    private readonly itsService: ItsService,
    private readonly userService: UserService,
    private readonly globalNavService: GlobalNavService,
    private readonly spaceService: SpaceService,
    iconRegistry: MatIconRegistry,
    domSanitizer: DomSanitizer,
    private contextSelectorService: ContextSelectorService,
    private defaultRoleService: DefaultRoleService
  ) {
    this.initializeIcons(iconRegistry, domSanitizer);
    this.initializeSelection();
    this.selection = { mode: 'multiple' };
  }

  private registrationsByType;

  private initializeIcons(iconRegistry: MatIconRegistry, domSanitizer: DomSanitizer): void {
    Object.keys(this.iconDefinitions).forEach((iconName: string) => {
      iconRegistry.addSvgIcon(iconName, domSanitizer.bypassSecurityTrustResourceUrl(this.iconDefinitions[iconName]));
    });
  }

  private initializeSelection(): void {
    if (!this.disableRoleSelection && !this.isOnboarding) {
      this.selectedRoles = [];
    }
  }

  private initializeSubscriptions(): void {
    const rolesSubscription = this.rolesService.businessRoles$
      .pipe(
        tap((roles) => {
          this.allSpaceRoles = roles;
          this.loadingRoles = false;
        }),
        filter(() => this.isOnboarding && !!this.managerLocale),
        tap(() => {
          this.setupDefaultRoles();
        }),
      )
      .subscribe();

    const loggedInUserSub = this.userService.loggedInUser$.subscribe((loggedInUser: User) => {
      if (loggedInUser) {
        this.loggedInUser = loggedInUser;
        this.initializeManagerSettings();
      }
    });

    const userSub = this.userService.user$.subscribe((user: User) => {
      if (user && this.mode === 'edit') {
        this.userDefaultNode = user.organization_id;
        this.userDefaultNodeLabel = user.organization_name;
        this.onChangeSelectedTab(0);
      }
    });

    const userRoleSub = this.globalNavService.userRolesList$.subscribe((roles: any) => {
      if (roles) {
        this.setupFilteredRoles(roles);
      }
    });

    const spacesSub = this.spaceService.spaces$.subscribe((spaces) => {
      this.spaces = spaces;
    });

    this.subscriptions.push(...[rolesSubscription, loggedInUserSub, userRoleSub, userSub, spacesSub]);
  }

  private initializeComponentState(): void {
    this.loadingRoles = true;
    this.initializeManagerSettings();
    this.rolesService.getSpaceRoles();
  }

  private setupFilteredRoles(roles: any): void {
    const consumerAdmin = roles.find((role) => role.business_role === 'CONSUMERS_USER_ADMIN') !== undefined;
    const userAdmin = roles.find((role) => role.business_role === 'USER_ADMIN') !== undefined;
    const showGeneralUser = consumerAdmin && !userAdmin;
    const roleSearchChange = merge(of(null), this.roleCtrl.valueChanges);

    this.filteredRoles$ = combineLatest([this.currentDRType, roleSearchChange]).pipe(
      map(([DRType, role]) => this._filterByDRType(DRType, role, showGeneralUser)),
      map((filteredRoles) => this._excludeSubscriptionRoles(filteredRoles)),
    );
  }

  ngOnInit() {
    this.initializeComponentState();
    this.initializeSubscriptions();
    this.setupSubscriptions();
  }

  private setupSubscriptions(): void {
    const contextSub = this.contextSelectorService.currentContext$.subscribe((context: Context[]) => {
      if (context && context.length > 0 && context[0].id !== '') {
        this.userDefaultNode = context[0].id;
        this.userDefaultNodeLabel = context[0].label;
        this.onChangeSelectedTab(0);
      }
    });

    const chipsFormControlSub = this.chipsFormControl.valueChanges.subscribe((selectedValues) => {
      if (!this.isOnboarding) {
        if (selectedValues && selectedValues.length > 0) {
          this.selectedRoles = selectedValues;
          this._validateFormWithRoles(this.selectedRoles);
        }
      }
    });

    this.subscriptions.push(...[contextSub, chipsFormControlSub]);
  }

  private initializeManagerSettings(): void {
    this.managerLocale = this.defaultRoleService.setManagerLocale(this.loggedInUser);
  }

  setupDefaultRoles(): void {
    const defaultRolesResult = this.defaultRoleService.getDefaultRoles(
      this.managerLocale,
      this.allSpaceRoles,
      this.isOnboarding,
    );
    this.selectedRoles = defaultRolesResult.roles;
    this.disableRoleSelection = defaultRolesResult.disableRoleSelection;
  }

  async onChangeSelectedTab(selectedTab) {
    this.currentTab = selectedTab;
    this.deselectAllLocations();
    this.nodes = [];
    if (!this.isOnboarding) {
      this.selectedRoles = [];
    }
    this.searchText = '';
    this.loadingHierarchy = true;
    this.chipsFormControl.disable();
    await new Promise((resolve) => setTimeout(resolve, 1000));
    let nodes;
    switch (selectedTab) {
      case 0:
        this.currentDRType.next('SpaceEntity');
        nodes = await this.loadOrganizationNodes(this.showOnlyPrimaryOrg);
        this.assignNodes(nodes, 0);
        break;
      case 1:
        this.currentDRType.next('DREntity');
        nodes = await this.loadMarketNodes();
        this.assignNodes(nodes, 1);
        break;
      case 2:
        this.currentDRType.next('SpaceEntity');
        nodes = await this.loadAdminGroupsNodes();
        this.assignNodes(nodes, 2);
        break;
      case 3:
        this.currentDRType.next('DREntity');
        nodes = await this.loadDRGroupsNodes();
        nodes.forEach((node) => {
          if (!node.hasOwnProperty('spaceType')) {
            node.spaceType = 'Partner';
          }
        });
        this.assignNodes(nodes, 3);
        break;
    }
  }

  assignNodes(nodes, nodeTab) {
    if (nodeTab === this.currentTab) {
      this.nodes = nodes;
      this.treeDataSubject.next(this.nodes);
      this.enableSelection();
    }
  }

  enableSelection() {
    this.chipsFormControl.enable();
    this.loadingHierarchy = false;
  }

  async loadOrganizationNodes(showOnlyPrimaryOrg?: boolean) {
    this.loadingHierarchy = true;
    this.orgnodes = [];
    if (showOnlyPrimaryOrg && this.userDefaultNode) {
      await this.spaceService.getOrgHierarchy(this.userDefaultNode);
      this.spaces = this.spaces.filter((orgs) => orgs.id === this.userDefaultNode);
      this.treeDataSubject.next(this.spaces);
      this.orgnodes = [...this.spaces];
    } else if (this.loadedALLOrgs.length > 0) {
      this.orgnodes = [...this.loadedALLOrgs];
      this.treeDataSubject.next(this.orgnodes);
      await new Promise((resolve) => setTimeout(resolve, 500));
    } else {
      await this.spaceService.getOrgHierarchy(this.userDefaultNode);

      this.spaces.forEach((org) => {
        if (!org.hasOwnProperty('children') || org.children === undefined || org.children.length === 0) {
          org.children = [
            {
              id: '0',
              parentId: org.id,
              organizationId: this.userDefaultNode,
              displayLabel: 'Loading...',
              spaceType: 'Loading',
            } as any,
          ];
        }
      });
      this.treeDataSubject.next(this.spaces);
      this.orgnodes = this.spaces;
      await new Promise((resolve) => setTimeout(resolve, 500));
      this.loadedALLOrgs = [...this.orgnodes];
    }
    this.searchText = '';
    this.currentSearch = '';
    this.assignNodes(this.orgnodes, 0);
    return this.orgnodes;
  }

  async loadMarketNodes() {
    if (!this.marketNodes || this.marketNodes.length <= 0) {
      this.marketNodes = await this.spaceService.getSpecificHierarchies([
        'operator',
        'program',
        'product',
        'portfolio',
      ]);
    }

    this.addLoadingPlaceholders(this.marketNodes);
    return this.marketNodes;
  }

  private addLoadingPlaceholders(nodes: TreeNode<any>[]): void {
    nodes.forEach((node) => {
      if (node.id === '0') {
        return;
      }
      if (!node.hasOwnProperty('children') || node.children === undefined || node.children.length === 0) {
        node.children = [
          {
            id: '0',
            parentId: node.id,
            organizationId: this.userDefaultNode,
            displayLabel: 'Loading...',
            spaceType: 'Loading',
          } as any,
        ];
      } else {
        this.addLoadingPlaceholders(node.children);
      }
    });
  }

  async loadRegistrationsForNode(node: TreeNode<any>) {
    if (!node.id || !node.drType || (node.drType !== 'Product' && node.drType !== 'Portfolio')) {
      return [];
    }

    return await this.spaceService.getSpecificHierarchies(['registration'], { id: node.id, dr_type: node.drType.toUpperCase() });
  }

  async loadAdminGroupsNodes() {
    if (!this.allAdminGroups || this.allAdminGroups.length <= 0) {
      this.allAdminGroups = await this.spaceService.getSpecificHierarchies(['admingroup']);
    }

    return this.allAdminGroups;
  }

  async loadDRGroupsNodes() {
    if (!this.drGroups || this.drGroups.length <= 0) {
      this.drGroups = await this.drGroupService.getDrGroups();
    }
    return this.drGroups;
  }

  updateFilteredRoles(searchText: string) {
    let showGeneralUser = false;
    const userRoles = this.globalNavService.userRolesList$.getValue();
    if (userRoles) {
      const consumerAdmin = userRoles.find((role: any) => role.business_role === 'CONSUMERS_USER_ADMIN') !== undefined;
      const userAdmin = userRoles.find((role: any) => role.business_role === 'USER_ADMIN') !== undefined;
      showGeneralUser = consumerAdmin && !userAdmin;
    }

    let filteredRoles = this._filterByDRType(this.currentDRType.getValue(), searchText, showGeneralUser);
    filteredRoles = this._excludeSubscriptionRoles(filteredRoles);

    this.filteredRoles$ = of(filteredRoles);
  }

  async applyRoles() {
    const newSpacesWithRoles = this.selectedSpaces.map((space: Group | TreeNode<any>) => {
      return {
        ...{
          id: space.id,
          displayLabel: space.displayLabel,
          spaceType: space.spaceType,
          drType: space.drType,
        },
        activeRoles: [],
        newRoles: [...this.selectedRoles],
      };
    });
    if (this.selectedRoles.length > 0) {
      this.onRoleAdd.emit();
    }

    const subscriptions: any[] = [];
    this.illegalSubs = [];
    newSpacesWithRoles.forEach((space) => {
      const entitySubscriptions = space.newRoles
        .map((role: any) => role.name)
        .filter((role: string) => DR_ROLES_TO_SUBSCRIPTIONS.includes(role));
      if (entitySubscriptions.length > 0 && space.spaceType === 'Site') {
        subscriptions.push({
          entity_id: space.id,
          entity_name: space.displayLabel,
          entity_type: space.spaceType,
          roles: entitySubscriptions,
        });
      }
    });

    if (subscriptions.length > 0 && this.hasEcrm) {
      const siteIds = subscriptions.map((sub) => sub.entity_id);
      const mappedSiteIds = await this.itsService.hasEcrmMapping(siteIds);
      const illegalSet = new Set();
      for (const sub of subscriptions) {
        if (!mappedSiteIds.includes(sub.entity_id)) {
          illegalSet.add(sub.entity_name);
        }
      }
      this.illegalSubs = Array.from(illegalSet);
      if (this.illegalSubs.length > 0) {
        return;
      }
    }
    this._validateFormWithRoles(this.selectedRoles);
    this.rolesService.newSpacesWithRoles$.next(newSpacesWithRoles);
  }

  handleSelection($event: TreeNode<any>[]) {
    if (Array.isArray($event)) {
      $event.forEach((treeNode) => {
        const index = this.selectedSpaces.findIndex((node) => node.id === treeNode.id);
        if (treeNode.id && index === -1) {
          this.selectedSpaces.push(treeNode);
          this.selectedKeys.add(treeNode);
        }
      });
    }
  }

  handleDeselection($event: TreeNode<any>[]) {
    if (Array.isArray($event) && $event.length === 0) {
      this.selectedSpaces = [];
      this.selectedKeys = new Set<TreeNode<any>>();
      return;
    }
    if (Array.isArray($event)) {
      this.selectedSpaces.forEach((node) => {
        const index = $event.findIndex((item) => item.id === node.id);
        if (index === -1) {
          this.selectedSpaces = this.selectedSpaces.filter((item) => item.id !== node.id);
          this.selectedKeys.delete(node);
        }
      });
    }

    this.selectedSpaces = [...this.selectedSpaces];
    this.selectedKeys = new Set(Array.from(this.selectedKeys));
  }

  selectAllLocations() {
    if (this.locationTree) {
      const rootNodes = this.treeDataSubject.value;
      this.selectedSpaces = [...rootNodes];
    }
  }

  deselectAllLocations() {
    if (this.locationTree) {
      this.locationTree.deselectAllNodes();
    }
  }

  removeRole(roleName: string): void {
    const role = this.allSpaceRoles.find((role) => role.name === roleName);

    if (role) {
      const currentValues = this.chipsFormControl.value || [];
      const updatedValues = currentValues.filter((val) => val.name !== role.name);
      this.chipsFormControl.setValue(updatedValues);
    }
  }

  private _validateFormWithRoles(role: BusinessRole[]) {
    this.roleError.emit();
    return true;
  }

  public checkRoleDisabled(roleName: string) {
    return false;
  }

  private _filterByDRType(asigned: string, typedRole: string | null, showGeneralUser: boolean): BusinessRole[] {
    return this.allSpaceRoles.filter((role) => {
      const included = role.assignedAt?.includes(asigned);
      if (!showGeneralUser) {
        if (typedRole && included) {
          const filterValue = typedRole.toLowerCase();
          return role.displayLabel.toLowerCase().indexOf(filterValue) !== -1;
        }
        return included;
      } else if (role.name === 'DR_GENERAL_USER') {
        return included;
      }
    });
  }

  isDisabled = (item: any) => {
    return !this.selectedKeys.has(item) && this.disableItems && !this.nodes.find((node) => node.id == item.id);
  };

  get checkboxSettings(): CheckableSettings {
    return {
      checkChildren: false,
      checkParents: false,
      enabled: true,
      mode: this.selection.mode,
      checkOnClick: false,
    };
  }

  async switchHierarchy(event) {
    this.showOnlyPrimaryOrg = event.value;
    await this.loadOrganizationNodes(this.showOnlyPrimaryOrg);
  }

  loadedOrgIds = [];

  public hasChildren = (node) => {
    if (!node) {
      return false;
    }
    if (node.drType === 'Organization') {
      if (!this.loadedOrgIds.includes(node.id) || node.children === undefined) {
        return true;
      }
      return node.children.length > 0;
    }
    return node.children && node.children.length > 0;
  };

  async fetchOrgsAsync(node): Promise<any> {
    if (this.showOnlyPrimaryOrg) {
      return node.children ? node.children : [];
    }
    if (node.children && node.children[0].id !== '0') {
      return node.children;
    }
    if (node.drType === 'Organization' && !this.loadedOrgIds.includes(node.id)) {
      await this.spaceService.getOrgHierarchy(node.id);
      const expandedOrg = this.spaces.find((org) => org.id === node.id);
      if (expandedOrg) {
        expandedOrg.children = expandedOrg.children || [];
        const storedNode = this.nodes.find((storedNode) => storedNode.id === node.id);
        if (storedNode) {
          storedNode.children = expandedOrg.children;
        }
        node.children = expandedOrg.children;
      }
      this.currentSearch = '';
      this.loadedOrgIds.push(node.id);
      return expandedOrg ? expandedOrg.children : [];
    } else {
      return node.children ? node.children : [];
    }
  }

  public async handleExpand(nodesFromEnelTree: TreeNode<any>[]) {
    if (nodesFromEnelTree.length > 0) {
      this.loadingHierarchy = true;
      for (const node1 of nodesFromEnelTree.filter((node) => node.children?.[0]?.id === '0')) {
        let children: any[] | void = [];
        if (node1.drType === 'Product' || node1.drType === 'Portfolio') {
          this.loadingHierarchy = false;
          children = await this.loadRegistrationsForNode(node1);
        } else if (node1.drType === 'Organization') {
          children = await this.fetchOrgsAsync(node1);
        }
        const currentTreeData = this.treeDataSubject.value;
        this.updateNodeChildren(currentTreeData, node1.id, children || []);
        this.treeDataSubject.next([...currentTreeData]);
      }
      this.loadingHierarchy = false;
    }
  }

  private updateNodeChildren(nodes: TreeNode<any>[], nodeId: string, children: any[]): boolean {
    for (const node of nodes) {
      if (node.id === nodeId) {
        node.children = children;
        return true;
      }
      if (node.children && node.children.length > 0) {
        const found = this.updateNodeChildren(node.children, nodeId, children);
        if (found) return true;
      }
    }
    return false;
  }

  isVisible = () => {
    return true;
  };

  currentSearch = '';
  currentResult = [];

  get filteredNodes() {
    if (this.searchText === '') {
      return this.nodes;
    }
    if (this.currentSearch === this.searchText) {
      return this.currentResult;
    } else {
      this.currentSearch = this.searchText;
      this.currentResult = this.filterByDisplayLabel(this.searchText);
      return this.currentResult;
    }
  }

  filterByDisplayLabel(searchText, nodes = this.nodes) {
    return nodes.reduce((filtered, node) => {
      const newItem = { ...node }; // Create a copy of the item to avoid mutation
      if (newItem.displayLabel.toLowerCase().includes(searchText.toLowerCase())) {
        filtered.push(newItem);
      } else if (newItem.children && newItem.children.length > 0) {
        const filteredChildren = this.filterByDisplayLabel(searchText, newItem.children); // Recursively filter children
        if (filteredChildren.length > 0) {
          newItem.children = filteredChildren;
          filtered.push(newItem);
        }
      }
      return filtered;
    }, []);
  }

  contains(text: string, term: string): boolean {
    return text.toLowerCase().indexOf((term || '').toLowerCase()) >= 0;
  }

  deselectAll() {
    if (this.isOnboarding) {
      return;
    }
    this.deselectAllLocations();
    this.roleCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
    this.roleInput.nativeElement.value = '';
    this.roleCtrl.setValue(null);

    this.selectedRoles = [];
    this.chipsFormControl.setValue(null);
  }

  _excludeSubscriptionRoles(roles: BusinessRole[]) {
    return roles.filter((role) => !DR_NOTIFICATION_ROLES.includes(role.name));
  }

  isRoleSelected(roleName: string): boolean {
    const selectedValues = this.chipsFormControl.value || [];
    return selectedValues.some((role) => role.name === roleName);
  }

  searchTextChange() {
    if (this.searchText === '') {
      this.treeDataSubject.next(this.nodes);
    }
    if (this.currentSearch === this.searchText) {
      this.treeDataSubject.next(this.currentResult);
    } else {
      this.currentSearch = this.searchText;
      this.currentResult = this.filterByDisplayLabel(this.searchText);
      this.treeDataSubject.next(this.currentResult);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
